export const TOUR_CATEGORY_ICONS = {
  // Bike
  Bike: "v2-bike",
  Biking: "v2-bike",
  "Bike and Cruise": "v2-bike",
  "E-Bike": "v2-bike",
  "Mountain Bike": "v2-bike",
  "Road Bike": "v2-bike",
  "Standard Biking": "v2-bike",
  // Climbing
  Climbing: "v2-mountains",
  Mountaineering: "v2-mountains",
  "Rock Climbing": "v2-mountains",
  // Cultural
  Cultural: "v2-globe-alt",
  "Cultural Sightseeing": "v2-globe-alt",
  Educational: "v2-globe-alt",
  Festival: "v2-globe-alt",
  Gastronomy: "v2-globe-alt",
  Overland: "v2-globe-alt",
  "Self-Drive": "v2-globe-alt",
  // Family - subsets use icons from other major categories
  Family: "v2-following",
  // Hiking
  Hiking: "v2-footprints",
  Pilgrimage: "v2-footprints",
  Trekking: "v2-footprints",
  Walking: "v2-footprints",
  "Horseback Riding": "v2-horse",
  Multisport: "v2-multi",
  // Snow
  Snow: "v2-snowflake",
  "Avalanche Training": "v2-snowflake",
  "Backcountry Ski": "v2-snowflake",
  "Cross-Country Skiing": "v2-snowflake",
  "Downhill Ski": "v2-snowflake",
  "Heli-Ski": "v2-snowflake",
  "Ice Climbing": "v2-snowflake",
  "Ski Touring": "v2-snowflake",
  Snowshoeing: "v2-snowflake",
  // Water
  Water: "v2-thick-Canoe",
  "Beach Holiday": "v2-thick-Canoe",
  Canoeing: "v2-thick-Canoe",
  Cruise: "v2-thick-Canoe",
  Rafting: "v2-thick-Canoe",
  "River Kayak": "v2-thick-Canoe",
  Sailing: "v2-thick-Canoe",
  "Scuba diving": "v2-thick-Canoe",
  "Sea Kayak": "v2-thick-Canoe",
  Snorkeling: "v2-thick-Canoe",
  Surfing: "v2-thick-Canoe",
  // Wellness
  Wellness: "v2-spa",
  Spa: "v2-spa",
  Yoga: "v2-spa",
  // Widlife
  Wildlife: "v2-paw",
  "Animal Supported": "v2-paw",
  Birdwatching: "v2-paw",
  Fishing: "v2-paw",
  Safari: "v2-paw",
  "Wildlife Watching": "v2-paw",
}
